import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

export const Divider = styled.hr<{
  $margin?: spacing | 0
}>`
  border: none;
  height: 1px;
  width: 100%;
  margin: 0;
  flex-shrink: 0;
  background-color: ${colors.divider};
  margin: ${(props) => props.$margin || spacing.XS} 0;
`
